// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__gY9i1","carousel":"styles_carousel__2i5WC","sideScroll":"styles_sideScroll__VWUsK"};